module.exports = __webpack_public_path__ + "static/img/signature_light.3599ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/signature_light.png
// module id = xkfU
// module chunks = 31